import { render, staticRenderFns } from "./TheSettingsDialog.vue?vue&type=template&id=42cccc37&"
import script from "./TheSettingsDialog.vue?vue&type=script&lang=js&"
export * from "./TheSettingsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports